import React from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import blockscopeLogo from 'blockscope/assets/logo/blockscope-green.svg';

const Logo = ({ at, width, className, textClass, ...rest }) => {
  return (
    <Link
      to='/'
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth',
          },
          className
        )}
      >
        <img className='me-2' src={blockscopeLogo} alt='Logo' width={width} />
        <span className={classNames('font-sans-serif', textClass, 'text-dark')}>
          Blockscope
        </span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
